import events from './events';

//
// Keep track of mounted manifest instances.
//
const instances = {};

/**
 * Setup listener for mount of React manifest instance.
 *
 * @param {String} type Expected mount of instance.
 * @returns {Function} Completion callback.
 * @api public
 */
export default function getInstance(type = 'header') {
  const event = `mount:${ type }`;

  //
  // Listen early to intercept the event before the helper is called and store the
  // instance for later calls to the helper.
  //
  events.once(event, instance => {
    instances[type] = instance;
  });

  return function getMountedInstance(done) {
    if (type in instances) {
      return done(null, instances[type]);
    }

    events.once(event, instance => {
      return done(null, instance);
    });
  };
}
